import Navigation from "@/components/Navigation"
import Footer from "@/components/Footer"

export default function MentionsLegales() {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="container mx-auto px-4 lg:px-8 py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl font-display font-bold mb-8 mt-6 text-center">Mentions légales et conditions générales d'utilisation</h1>
          
          <div className="prose prose-lg max-w-none space-y-8">

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">1. Préambule</h2>
              <p className="text-muted-foreground">
                Bienvenue sur notre site www.wememberz.com !

<br/><br/>
Comme la loi nous l’impose, vous trouverez ci-dessous nos mentions légales ainsi qu’un ensemble de règles qui fixent les conditions d’utilisation de notre site web. En l’utilisant, vous êtes réputés avoir pris connaissance et accepté les termes de la présente notice légale.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">2. Mentions obligatoires</h2>
              <p className="text-muted-foreground">
                <b>Éditeur du site</b><br/>
                Le site est édité et appartient à la société 1Year1Book, SARL au capital de 4 500€.<br/>
Siège social : 18 rue rubens, 75013 Paris<br/>
SIRET : 523 806 669 000 17 Code APE : 6201Z<br/>
Adresse email : contact@wememberz.com<br/><br/>
                <b>Gestion éditoriale du site</b><br/>
                Directeur de la publication : Hubert Dalstein<br/><br/>
                <b>Hébergeur du site</b><br/>
                Nom de la société : HEROKU<br/>
                Siège social : San Francisco, CA, USA
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">3. Accès et service</h2>
              <p className="text-muted-foreground">
L’accès à notre site est libre, nous nous engageons à mettre en œuvre tous les moyens à notre disposition pour assurer la fiabilité du site et de ses contenus.

<br/><br/>
Néanmoins, nous n’accordons aucune garantie quant à l’accès au site et nous nous réservons le droit de modifier le site ainsi que ses contenus sans aucun préavis, notre responsabilité ne pouvant être engagée à ce titre.

<br/><br/>
Nous attirons votre attention sur les écarts possibles entre notre site web accessible via ordinateur et la version accessible sur tablette ou mobile.
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">4. Conditions d’utilisation</h2>
              <p className="text-muted-foreground">
Nous déclinons toute responsabilité sur l’utilisation du site et de ses contenus, et nous ne saurions être tenus responsables en cas d’erreur, d’interruption, de dysfonctionnement, de perte de données, de saturation du réseau internet, de défaillance de tout matériel de réception ou des lignes de communication, ou de tout autre évènement impactant ou résultant de l’utilisation du présent site.

<br/><br/>
Vous vous interdisez tout acte de nature à altérer ou perturber, de quelque manière que ce soit, le fonctionnement normal du site. De même, vous vous interdisez toute utilisation détournée des informations nominatives présentes sur le site.

<br/><br/>
Si vous constatez un dysfonctionnement du site, nous vous invitons à nous contacter aux coordonnées indiquées à l’article intitulé « Mentions obligatoires ».
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">5. Informations et contenus</h2>
              <p className="text-muted-foreground">
Les informations ou contenus diffusés et accessibles sur notre site sont communiqués à titre gratuit.
<br/><br/>

L’utilisation d’informations et de contenu est placée sous votre responsabilité et ne saurait aucunement nous engager.
<br/><br/>

Si vous estimez qu’un contenu est inapproprié, nous vous invitons à nous contacter.
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">6. Données à caractère personnel</h2>
              <p className="text-muted-foreground">
Soucieux de protéger la vie privée de nos utilisateurs et dans la mesure où nous sommes susceptibles de traiter vos données à caractère personnel lorsque vous naviguez sur notre site, nous nous engageons à respecter la réglementation applicable en la matière et à nous conformer à notre politique de protection des données accessible “Confidentialité”.
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">7. Propriété intellectuelle</h2>
              <p className="text-muted-foreground">
Ce site est notre propriété exclusive. Nous sommes à ce titre seuls titulaires de l’ensemble des droits de propriété intellectuelle portant sur ce site et son contenu soit notamment :
<br/><br/>
 - les droits d’auteur portant sur les contenus,<br/>
 - les droits de propriété industrielle portant sur nos marques et logos,<br/>
 - les droits de propriété intellectuelle portant sur nos noms de domaine,<br/>
 - les droits de propriété intellectuelle portant sur l’ensemble de nos identifiants sur les réseaux sociaux,<br/>
 - les droits sui generis du producteur de bases données sur les bases de données que nous sommes susceptibles de mettre à votre disposition.
<br/><br/>
Une visite sur notre site ne constitue une cession de droit d’aucune sorte. Vous bénéficiez cependant d’un droit d’usage personnel et un droit de copie de nos contenus pour un usage privé uniquement.
<br/><br/>

Toute extraction, par transfert permanent ou temporaire, de la totalité ou d'une partie du contenu du présent site ou des bases de données qu’il contient sur un autre support, par tout moyen ou sous toute forme que ce soit, ainsi que la réutilisation, par la mise à disposition du public de la totalité ou d'une partie du contenu du présent site, quelle qu'en soit la forme, est illicite.
<br/><br/>

Tous les éléments (textes, commentaires, ouvrages, illustrations, logos, marques, vidéos et images, sans que cette liste soit limitative) affichés ou cités sur le présent site sont la propriété exclusive de leurs titulaires respectifs. Conformément au Code de la Propriété Intellectuelle, toute utilisation ou reproduction totale ou partielle desdits éléments effectuée à partir du présent site sans notre autorisation expresse et écrite est interdite.
<br/><br/>

Pour tout autre usage et notamment reproduction (hors copie privée) de nos contenus, nous vous invitons à nous contacter aux coordonnées indiquées à l’article intitulé « Mentions obligatoires ».
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">8. Newsletter</h2>
              <p className="text-muted-foreground">
Nous vous proposons de vous abonner à notre newsletter.
<br/><br/>

Sans que cela ne constitue un engagement de notre part, cette newsletter vous permet à une fréquence régulière de recevoir des informations sous forme électronique.

<br/><br/>
Vous pouvez vous désabonner à tout moment de cette newsletter en activant le lien de désabonnement contenu dans chaque newsletter.
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">9. Formulaire de contact</h2>
              <p className="text-muted-foreground">
Notre formulaire de contact vous permet de nous écrire. Ces échanges sont confidentiels. Nous traiterons vos demandes dès que possible, sans engagement de délai ni de réponse.
<br/>
Ce formulaire ne doit pas être utilisé dans le cadre de réclamations pour lesquelles vous êtes invité à prendre directement contact avec votre interlocuteur habituel.
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">10. Espace candidature</h2>
              <p className="text-muted-foreground">
Vous pouvez soumettre votre candidature aux formations que nous proposons par le formulaire de contact accessible depuis la page d’accueil du site.
             
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">11. Annonce publicitaire</h2>
              <p className="text-muted-foreground">
Notre site est susceptible de comporter des annonces publicitaires. Les annonces publicitaires sont clairement identifiées.

<br/><br/>
Notre site peut également accueillir des annonces publicitaires de tiers. Nous ne sommes pas responsables du contenu de ces publicités, et en cas de difficulté nous vous invitons à contacter directement les annonceurs identifiés.
                
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">12. Lien Hypertextes</h2>
              <p className="text-muted-foreground">
Notre site contient des liens vers d’autres espaces numériques. Nous accordons un grand soin à la sélection de ces liens mais nous ne sommes pas responsables du contenu des espaces numériques de tiers auxquels vous pouvez accéder via ces derniers.
               
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">13. Convention de preuve</h2>
              <p className="text-muted-foreground">
Les données d’identification ou de connexion constituent des éléments de preuve.
              </p>
            </section>

    

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">14. Langue</h2>
              <p className="text-muted-foreground">
La langue officielle de notre site est le français.
  <br/>  <br/>

Au cas où nous déciderions de publier des contenus en langue étrangère, nous ne serions en aucun cas responsable des traductions automatiques réalisées via des navigateurs web et autres outils de traduction automatique que vous seriez susceptible d’utiliser.
                <br/>
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">15. Droit applicable</h2>
              <p className="text-muted-foreground">
La présente notice légale et l’ensemble de notre site relève du droit français et toute difficulté sera tranchée par le ressort de la juridiction du lieu de notre siège social.
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">16. Mise à jour</h2>
              <p className="text-muted-foreground">
Nous nous réservons le droit de modifier la présentation et le contenu de la présente notice légale. La notice légale en vigueur est celle accessible sur notre site web ou tout autre espace numérique au jour de votre visite.
              </p>
            </section>

                        <section>
              <h2 className="text-2xl font-semibold mb-4 text-foreground">17. Pour plus d’informations</h2>
              <p className="text-muted-foreground">
Pour toute question relative à notre notice légale, vous êtes invité à nous contacter aux coordonnées indiquées à l’article intitulé « Mentions obligatoires » des présentes.
              </p>
            </section>


            

          </div>
        </div>
      </main>
      <Footer />
    </div>
  )
}